// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dece2e673c--wrapper--t2Ia3"};